import { jsx as e, jsxs as r } from "react/jsx-runtime";

import { forwardRef as o, useRef as t, useImperativeHandle as a } from "react";

import l from "@ui-components-3/ui/lib/components/FormControl";

import i from "@ui-components-3/ui/lib/components/Select";

import s from "@ui-components-3/ui/lib/utils/classNames";

import n from "./Calendar/index.js";

import m from "./AvailabilityDrawer/index.js";

import d from "./Legend/index.js";

import { calendarViewModeOptions as p } from "../utils.js";

import { useProviderScheduleModel as c, ProviderScheduleContext as u } from "../hooks/useProviderSchedule.js";

import f from "../test-ids.js";

const x = o(((o, x) => {
    const h = t(null), b = c(o), {mode: w, onChangeMode: v, variantClassNames: g, toggleDrawer: C} = b;
    return a(x, (() => ({
        openDrawer: C(!0),
        resetDrawer: () => h?.current?.resetFlow(),
        showCreateError: () => h?.current?.showCreateError()
    })), [ C ]), e(u.Provider, {
        value: b,
        children: r("div", {
            "data-testid": f.root.view,
            children: [ e("div", {
                className: "md:pt-m md:pb-l bg-neutral-900 md:px-5",
                children: r("div", {
                    className: "p-m flex flex-col gap-6 bg-white md:rounded-2xl md:shadow-[0px_8px_16px_0px_rgba(27,99,162,0.08)]",
                    children: [ r("div", {
                        className: "gap-m flex flex-col flex-wrap justify-between sm:flex-row",
                        "data-testid": f.root.header,
                        children: [ e(d, {}), r("div", {
                            className: "gap-m flex flex-col sm:flex-row",
                            children: [ e(l, {
                                label: "Calendar View",
                                className: "min-w-[180px]",
                                LabelProps: {
                                    className: "text-neutral-800 !font-semibold"
                                },
                                children: e(i, {
                                    options: p,
                                    getOptionValue: e => e.value,
                                    getOptionLabel: e => e.label,
                                    value: w,
                                    onChange: v
                                })
                            }), e("button", {
                                type: "button",
                                className: s("btn w-full shrink-0 sm:mt-[27.5px] sm:w-auto", g.buttonMain),
                                onClick: C(!0),
                                children: "Manage Availability"
                            }) ]
                        }) ]
                    }), e("hr", {}), e(n, {
                        "data-testid": f.calendar.view
                    }) ]
                })
            }), e(m, {
                ref: h
            }) ]
        })
    });
}));

x.displayName = "ProviderScheduleCalendar";

export { x as default };
//# sourceMappingURL=ProviderScheduleCalendar.js.map
